import { render, staticRenderFns } from "./ClientSuspend.vue?vue&type=template&id=e7bd0bf6&scoped=true"
import script from "./ClientSuspend.vue?vue&type=script&lang=js"
export * from "./ClientSuspend.vue?vue&type=script&lang=js"
import style0 from "./ClientSuspend.vue?vue&type=style&index=0&id=e7bd0bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bd0bf6",
  null
  
)

export default component.exports